<nz-table
  #historyTable
  [nzData]="userSkillHistory"
  [nzLoading]="skillService.loading$ | async"
  [nzNoResult]="noData"
  >
  <thead>
    <tr>
      <th>Skill</th>
      <th>Label</th>
      <th>Rubric Code</th>
      <th>Rubric Level</th>
      <th>Created</th>
      <th>Updated</th>
      <th>Client UUID</th>
      <th>Course UUID</th>
      <th>Location UUID</th>
      <th>Section UUID</th>
      <th>Unit UUID</th>
      <th>Lesson UUID</th>
      <th>Activity UUID</th>
      <th>Content UUID</th>
      <th>Take</th>
    </tr>
  </thead>
  <tbody>
    @for (history of userSkillHistory; track history) {
      <tr>
        <td>{{ history.skill_code }}</td>
        <td>{{ history.skill?.label || 'N/A' }}</td>
        <td>{{ history.rubric_code || 'N/A' }}</td>
        <td>{{ history.rubric_level_level }}</td>
        <td>{{ history.created | date: 'medium' }}</td>
        <td>{{ history.updated | date: 'medium' }}</td>
        <td>{{ history.client_uuid || 'N/A' }}</td>
        <td>{{ history.course_uuid || 'N/A' }}</td>
        <td>{{ history.location_uuid || 'N/A' }}</td>
        <td>{{ history.section_uuid || 'N/A' }}</td>
        <td>{{ history.unit_uuid || 'N/A' }}</td>
        <td>{{ history.lesson_uuid || 'N/A' }}</td>
        <td>{{ history.activity_uuid || 'N/A' }}</td>
        <td>{{ history.content_uuid || 'N/A' }}</td>
        <td>{{ history.take ?? 'N/A' }}</td>
      </tr>
    }
  </tbody>
  <ng-template #noData>
    <nz-typography>No skill history available</nz-typography>
  </ng-template>
</nz-table>
